import { RECOMMEND_TAG_TYPE } from '../../../../constants/service/app/tagConstants';
import { _LIST_PAGINATION_MODEL } from '../../app/models';

/**
 *  추천 태그 리스트 검색 박스 모델
 */
export const RECOMMEND_TAG_LIST_SEARCH_DATA_MODEL = {
  /**
   *  추천 태그 타입
   */
  recommendTagType: RECOMMEND_TAG_TYPE.SEARCH_RECOMMEND,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 태그 생성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  추천 태그 리스트 검색 옵션 모델
 */
export const RECOMMEND_TAG_LIST_SEARCH_OPTION_MODEL = {
  /**
   *  추천 태그 타입
   */
  recommendTagType: RECOMMEND_TAG_TYPE.SEARCH_RECOMMEND,
  /**
   *  추천인
   */
  adminName: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  추천 상품 후기 생성일
   */
  createDate: null,
};

/**
 *  추천 태그에 연결할 아이템 리스트 필터 옵션 모델
 */
export const RECOMMEND_TAG_ITEM_LIST_FILTER_OPTION_MODEL = {
  /**
   *  태그 id
   */
  tagId: null,
  /**
   *  태그명
   */
  tagName: null,
};

/**
 *  추천 태그에 연결할 아이템 리스트 필터 정렬 모델
 */
export const RECOMMEND_TAG_ITEM_LIST_SORT_OPTION_MODEL = {
  /**
   *  태그 이미지 존재 여부
   */
  url: null,
  /**
   *  생성일
   */
  createDate: 'descend',
};

/**
 *  추천 태그 등록/복사
 */
export const RECOMMEND_TAG_SAVE_MODEL = {
  /**
   *  추천 태그 정보
   */
  recommendTagInfo: {
    /**
     *  추천 태그 타입
     */
    type: RECOMMEND_TAG_TYPE.SEARCH_RECOMMEND,
    /**
     *  메모
     */
    memo: null,
  },
  /**
   *  추천 태그 아이템 리스트
   */
  recommendTagItemList: {
    /**
     *  추천 태그에 연결할 아이템 리스트
     */
    itemList: {
      /**
       * 리스트
       */
      list: [],
      /**
       *  필터 옵션
       */
      filterOption: RECOMMEND_TAG_ITEM_LIST_FILTER_OPTION_MODEL,
      /**
       *  정렬 옵션
       */
      sortOption: RECOMMEND_TAG_ITEM_LIST_SORT_OPTION_MODEL,
      /**
       * pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    },
    /**
     *  선택된 추천 상품 후기에 연결된 아이템 리스트
     */
    selectedItemList: {
      list: [],
      idList: [],
    },
  },
};
